import React from 'react';

const AuthForm = ({
  authMode,
  setAuthMode,
  authError,
  email,
  setEmail,
  password,
  setPassword,
  handleSignIn,
  handleSignUp,
  onClose,
  guestCardCount = 0,
}) => {
  const isSignup = authMode === 'signup';
  const isSuccess = authError && authError.includes('Check your email');

  return (
    <div className="auth-root">
      {onClose && (
        <button className="auth-back" onClick={onClose} type="button">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5" /><path d="m12 19-7-7 7-7" />
          </svg>
          Back to cards
        </button>
      )}

      <div className="auth-inner">
        <div className="rp-logo-tile" aria-label="Ripety" role="img">字</div>

        <div className="auth-card">
          <h1 className="auth-title">{isSignup ? 'Create your account' : 'Welcome back'}</h1>
          <p className="auth-subtitle">
            {isSignup
              ? 'Keep your progress on every device.'
              : 'Pick up exactly where you left off.'}
          </p>

          {isSignup && guestCardCount > 0 && (
            <p className="auth-context">
              Your <strong>{guestCardCount} cards</strong> will be saved to this account.
            </p>
          )}

          {authError && (
            <p className={`auth-alert ${isSuccess ? 'auth-alert-ok' : 'auth-alert-bad'}`} role="status">
              {authError}
            </p>
          )}

          <form onSubmit={isSignup ? handleSignUp : handleSignIn}>
            <label className="auth-label" htmlFor="auth-email">Email</label>
            <input
              id="auth-email"
              className="auth-input"
              type="email"
              autoComplete="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <label className="auth-label" htmlFor="auth-password">Password</label>
            <input
              id="auth-password"
              className="auth-input"
              type="password"
              autoComplete={isSignup ? 'new-password' : 'current-password'}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button type="submit" className="rp-btn rp-btn-primary auth-submit">
              {isSignup ? 'Create account' : 'Sign in'}
            </button>
          </form>

          <button
            type="button"
            className="auth-switch"
            onClick={() => setAuthMode(isSignup ? 'login' : 'signup')}
          >
            {isSignup ? 'Already have an account? Sign in' : "New here? Create an account"}
          </button>

          {onClose && (
            <div className="auth-foot">
              <button type="button" className="rp-btn rp-btn-quiet" onClick={onClose}>
                Not now — keep swiping
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthForm;
